<template>
    <div class="form-body">
        <div class="flights-section">
            <div class="flight-data-item" v-for="(flight, i) of multiCityModel.flightsData" :key="flight.key">
                <AirportSearchSelector
                    v-model="flight.from"
                    :label-name="'Departure'"
                    :placeholder="'From airport'"
                    :error="errors.flightsData && errors.flightsData.length > i ? errors.flightsData[i].from : ''"
                />
                <AirportSearchSelector
                    v-model="flight.to"
                    :label-name="'Arrival'"
                    :placeholder="'To airport'"
                    :error="errors.flightsData && errors.flightsData.length > i ? errors.flightsData[i].to : ''"
                />
                <DatePickerField
                    class="multi-city-date"
                    :labelName="'Departing'"
                    :initialDate="flight.flyDate"
                    v-model="flight.flyDate"
                    @change="dateSelected(i, flight.flyDate)"
                    :disableDatesProp="getDisabledDate(i)"
                    :error="errors.flightsData && errors.flightsData.length > i ? errors.flightsData[i].flyDate : ''"
                />
                <div v-if="i > 1" class="delete-icon-svg" v-on:click="deleteFlight(flight, i)">
                    <img src="../../../../../assets/main_images/delete-svg.png" alt="delete-icon" class="delete-icon" />
                    <div class="mobile-delete-button">Remove Flight</div>
                </div>
            </div>
            <button class="add-flight-button" v-on:click="addFlight">
                <span class="plus-char">+</span> Add flight
            </button>
        </div>
        <div class="flight-bottom-data">
            <SimpleInputField
                v-model="multiCityModel.personData.name"
                :for-id="'nameOfMc'"
                :label-name="'Name'"
                :placeholder="'Enter your name'"
                :error="errors.name"
            />
            <SimpleInputField
                v-model="multiCityModel.personData.email"
                :for-id="'userEmail'"
                :type="'email'"
                :label-name="'Email'"
                :placeholder="'Enter your email'"
                :error="errors.email"
            />
            <InputTelField
                class="input-tel-phone"
                :initial-value="multiCityModel.personData.phone"
                :labelName="'Phone'"
                v-model="multiCityModel.personData.phone"
                :for-id="'phoneNumber'"
                :placeholder="'Enter your phone'"
                :error="errors.phone"
                @valid="is_phone_valid = $event"
            />
            <SelectField
                :optionsArray="passengersCountOptions"
                :initialValue="multiCityModel.passengersCount"
                v-model="multiCityModel.passengersCount"
                :label-name="'Passengers'"
                :placeholder="'Select a number'"
                :error="errors.passengersCount"
            />
            <SelectField
                :optionsArray="cabinClassesOptions"
                :initialValue="multiCityModel.cabinClass"
                v-model="multiCityModel.cabinClass"
                :label-name="'Cabin class'"
                :placeholder="'Select a class'"
                :error="errors.cabinClass"
            />
            <button class="btn" :class="{ loading: is_submiting }" :disabled="is_submiting" @click="validateForm()">
                <BounceSpinner v-if="is_submiting" color="#fff" />
                <span v-else>Get Quote</span>
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import _cloneDeep from 'lodash/cloneDeep'
import AirportSearchSelector from './form-fields/AirportsSearchSelector'
import SimpleInputField from './form-fields/SimpleInputField'
import SelectField from './form-fields/select-field'
import DatePickerField from './form-fields/date-picker-field'
import InputTelField from './form-fields/InputTelField'
import BounceSpinner from '../../spinners/BounceSpinner'
import { Validators } from '../use-cases/validators'
import helper from '@/helper.js'
import moment from 'moment'

export default {
    name: 'MultiCityForm',
    components: {
        InputTelField,
        DatePickerField,
        SelectField,
        SimpleInputField,
        AirportSearchSelector,
        BounceSpinner,
    },
    props: ['cabinClassesOptions', 'passengersCountOptions'],
    data() {
        return {
            is_submiting: false,
            multiCityModel: {
                type: 'multi_city',
                flightsData: [
                    {
                        from: null,
                        to: null,
                        flyDate: new Date(),
                    },
                    {
                        from: null,
                        to: null,
                        flyDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1),
                    },
                ],
                passengersCount: null,
                cabinClass: null,
                personData: {
                    name: null,
                    email: null,
                    phone: null,
                },
                suid: null,
            },
            errors: {
                flightsData: [],
            },
            valid: true,
            is_phone_valid: false,
        }
    },
    created() {
        this.getCustomKey()

        this.multiCityModel.passengersCount = this.passengersCountOptions.find((o) => o.value === 1)
        this.multiCityModel.cabinClass = this.cabinClassesOptions.find((o) => o.value === 'business')

        // Search unique ID
        this.multiCityModel.suid = helper.generateUniqueID()
    },
    methods: {
        getCustomKey() {
            this.multiCityModel.flightsData.forEach((el) => {
                if (!el.key) {
                    el.key = Math.random().toString(36).substring(7)
                }
            })
        },
        validateFlightsData() {
            this.multiCityModel.flightsData.forEach((el) => {
                let errorBox = {}
                Object.keys(el).map((arrayItemKey) => {
                    let validator
                    if (arrayItemKey !== 'to') {
                        validator = Validators.required(el[arrayItemKey])
                    } else {
                        validator = Validators.validateDestination(el.from, el[arrayItemKey])
                    }
                    errorBox[arrayItemKey] = validator.error
                    if (this.valid) {
                        this.valid = validator.valid
                    }
                })
                this.errors.flightsData.push(errorBox)
            })
        },
        validateForm() {
            this.errors = {
                flightsData: [],
            }
            this.valid = true

            this.validateFlightsData()

            Object.keys(this.multiCityModel.personData).map((key) => {
                let validatorBox
                if (key !== 'email') {
                    validatorBox = Validators.required(this.multiCityModel.personData[key])
                } else {
                    validatorBox = Validators.validateEmail(this.multiCityModel.personData[key])
                }
                this.errors[key] = validatorBox.error
                if (this.valid) {
                    this.valid = validatorBox.valid
                }
            })

            this.errors.cabinClass = Validators.required(this.multiCityModel.cabinClass).error
            if (this.valid) {
                this.valid = Validators.required(this.multiCityModel.cabinClass).valid
            }
            this.errors.passengersCount = Validators.required(this.multiCityModel.passengersCount).error
            if (this.valid) {
                this.valid = Validators.required(this.multiCityModel.passengersCount).valid
            }

            if (!this.is_phone_valid) this.valid = false

            if (this.valid) {
                this.submitForm()
            }
        },
        submitForm() {
            this.is_submiting = true

            const data = _cloneDeep(this.multiCityModel)
            data.cabinClass = this.multiCityModel.cabinClass.value
            data.passengersCount = this.multiCityModel.passengersCount.value
            data.flightsData = this.multiCityModel.flightsData.map((flight) => ({
                ...flight,
                from: flight.from.iata_code,
                to: flight.to.iata_code,
            }))

            // Clean phone
            if (data.personData.phone) data.personData.phone = data.personData.phone.split(/[^\d+]/).join('')

            // Transform data for new api version
            const newData = {
                suid: data.suid,
                trip_type: data.type,
                passengers: {
                    adult: data.passengersCount,
                    child: 0,
                    infant: 0,
                },
                cabin_class: data.cabinClass,
                client: data.personData,
                flights: data.flightsData.map((flight) => ({
                    from: flight.from,
                    to: flight.to,
                    departure: moment(flight.flyDate.getTime()).format('YYYY-MM-DD'),
                })),
            }

            axios
                .post(this.$globalConfig.api.base() + 'a/create_request', {
                    ...newData,
                    ...this.$root.getMarketingData(),
                })
                .then((response) => {
                    if (response && response.data.success) {
                        // Send Ecommerce Product Clicks event
                        this.sendAnalyticsEventProductClicks(this.multiCityModel.cabinClass.value)
                        // Send Ecommerce Product Details event
                        this.sendAnalyticsEventProductDetails(this.multiCityModel.cabinClass.value)

                        helper.yaMetrika.track('reachGoal', 'getaquote')
                        helper.yaMetrika.track('reachGoal', 'getthebestprice')

                        this.$root.cleanMarketingData()

                        this.$router.push({
                            path: '/finish',
                            query: {
                                name: this.multiCityModel.personData.name,
                            },
                        })
                    } else {
                        alert('Error occurred. Please try again or contact us.')
                    }
                })
                .finally(() => {
                    this.is_submiting = false
                })
        },
        addFlight() {
            const flightsLength = this.multiCityModel.flightsData.length
            if (flightsLength < 5) {
                const lastFlightDate = this.multiCityModel.flightsData[flightsLength - 1].flyDate
                this.multiCityModel.flightsData.push({
                    from: null,
                    to: null,
                    flyDate: new Date(
                        lastFlightDate.getFullYear(),
                        lastFlightDate.getMonth(),
                        lastFlightDate.getDate() + 1
                    ),
                })
                this.getCustomKey()
            }
        },
        deleteFlight(flight, index) {
            if (this.multiCityModel.flightsData && this.multiCityModel.flightsData.length > 2) {
                if (this.multiCityModel.flightsData[index] === flight) {
                    this.multiCityModel.flightsData.splice(index, 1)
                } else {
                    const i = this.multiCityModel.flightsData.indexOf(flight)
                    this.multiCityModel.flightsData.splice(i, 1)
                }
            }
        },
        dateSelected(index, dateEmitted) {
            const newDate = new Date(dateEmitted)
            if (newDate && this.multiCityModel.flightsData[index].flyDate !== newDate) {
                this.multiCityModel.flightsData[index].flyDate = newDate
            }
            for (let i = index; i < this.multiCityModel.flightsData.length; i++) {
                if (
                    this.multiCityModel.flightsData[i].flyDate &&
                    newDate > this.multiCityModel.flightsData[i].flyDate
                ) {
                    this.multiCityModel.flightsData[i].flyDate = new Date(
                        newDate.getFullYear(),
                        newDate.getMonth(),
                        newDate.getDate()
                    )
                }
            }
        },
        getDisabledDate(i) {
            if (this.multiCityModel.flightsData[i - 1] && this.multiCityModel.flightsData[i - 1].flyDate) {
                return { to: this.multiCityModel.flightsData[i - 1].flyDate }
            } else if (i === 0) {
                return { to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()) }
            }
        },
        getAnalyticsProducts(cabinClass) {
            return this.multiCityModel.flightsData.map((flight) => {
                const flyDateString = moment(flight.flyDate.getTime()).format('YYYY.MM.DD')

                return {
                    name: `${flight.from.iata_code}-${flight.to.iata_code} ${cabinClass.replace(
                        '_',
                        ' '
                    )} ${flyDateString}`.toUpperCase(),
                    id: `${flight.from.iata_code}-${flight.to.iata_code}_${cabinClass}_${flyDateString}`.toLowerCase(),
                    dimension1: flight.from.iata_code.toUpperCase(), // origin
                    dimension2: flight.to.iata_code.toUpperCase(), // destination
                    dimension3: cabinClass.replace('_', ' ').toLowerCase(), // cabin
                    dimension4: this.multiCityModel.cabinClass.value, // trip_type
                    dimension5: `${flight.from.iata_code}-${flight.to.iata_code}`.toUpperCase(), // route
                    metric1: parseInt(this.multiCityModel.passengersCount.value), // adult
                    metric2: 0, // child
                    metric3: 0, // infant
                }
            })
        },
        sendAnalyticsEventProductClicks(cabinClass) {
            this.$gtm.trackEcommerceEvent(
                {
                    click: {
                        actionField: {
                            list: 'search form',
                        },
                        products: this.getAnalyticsProducts(cabinClass),
                    },
                },
                'Product Clicks',
                false,
                {
                    suid: this.multiCityModel.suid,
                }
            )
        },
        sendAnalyticsEventProductDetails(cabinClass) {
            this.$gtm.trackEcommerceEvent(
                {
                    detail: {
                        actionField: {
                            list: 'search result',
                        },
                        products: this.getAnalyticsProducts(cabinClass),
                    },
                },
                'Product Details',
                true,
                {
                    suid: this.multiCityModel.suid,
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/global-styles';

* {
    box-sizing: border-box;
}

.form-body {
    flex-wrap: nowrap;
    flex-direction: column;
    padding: 0 20px 20px;
    max-width: 800px;

    .btn {
        margin: 20px auto;
        position: relative;
    }

    .flights-section {
        width: 100%;

        .flight-data-item {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin: auto;
            align-items: center;
            position: relative;

            .input-block {
                flex-basis: unset;
                max-width: unset;
                padding: 5px 15px;
                margin: 5px;
                width: calc(50% - 10px);

                border: 1px solid #f6f6f9;
                border-radius: 6px;

                &.multi-city-date {
                    width: 100%;
                }

                >>> .error-message {
                    left: 15px;
                }
            }

            .delete-icon-svg {
                border-radius: 50%;
                /*background: rgba(192, 192, 201, 0.12) 0% 0% no-repeat padding-box;*/
                display: flex;
                align-items: center;
                padding: 3px;
                cursor: pointer;
                position: absolute;
                right: -20px;
                top: 50%;
                transform: translateY(-50%);

                .delete-icon {
                    width: 20px;
                    height: 20px;
                }

                .mobile-delete-button {
                    display: none;
                }
            }
        }

        .input-block {
            flex-basis: 33.33%;
        }

        .add-flight-button {
            font-family: 'Gilroy-Medium', sans-serif;
            font-size: 14px;
            line-height: 17px;
            cursor: pointer;
            outline: none;
            color: $mainTextBlueColor;
            background: transparent;
            border: 0.5px solid $mainTextBlueColor;
            border-radius: 4px;
            padding: 5px 20px;
            margin: 10px 20px 15px;
            display: flex;
            align-items: center;

            .plus-char {
                font-size: 22px;
                line-height: 20px;
                margin-right: 5px;
            }

            &:hover {
                border-color: $mainTextBlueColor;
                transform: scale(1.03);
                transition-duration: 0.3s;
            }
        }
    }

    .flight-bottom-data {
        display: flex;
        max-width: 100%;
        flex-wrap: wrap;

        .input-block {
            flex-basis: unset;
            padding: 5px 15px;
            margin: 5px;
            width: calc(50% - 10px);

            border: 1px solid #f6f6f9;
            border-radius: 6px;

            >>> .error-message {
                left: 15px;
            }
        }

        .input-tel-phone {
            &.input-block {
                flex-basis: 100%;
                width: 100%;
            }
        }
    }
}

@media (max-width: 768px) {
    .form-body {
        border-top-right-radius: 0;

        .flights-section {
            width: 100%;

            .flight-data-item {
                display: flex;
                flex-wrap: wrap;
                align-items: flex-start;

                .input-block {
                    width: calc(50% - 10px);
                    flex-basis: unset;
                    padding: 10px;

                    &.multi-city-date {
                        width: 100%;
                    }

                    >>> .error-message {
                        left: 11px;
                    }
                }

                .delete-icon-svg {
                    border-radius: 0;
                    background: transparent;
                    display: flex;
                    justify-content: center;
                    padding: 0;
                    margin: 25px auto 5px;
                    width: 100%;
                    position: relative;
                    right: unset;

                    .delete-icon {
                        position: relative;
                        max-width: 20px;
                        margin: 0 10px 0 0;
                        width: 15px;
                        height: 15px;
                    }

                    .mobile-delete-button {
                        display: flex;
                        font-family: 'Gilroy-Medium', sans-serif;
                        font-size: 14px;
                        line-height: 17px;
                        color: $mainTextBlueColor;
                        position: relative;
                    }
                }
            }

            .add-flight-button {
                font-size: 17px;
                line-height: 20px;
                padding: 10px 24px;
                margin: 10px auto 15px;

                .plus-char {
                    font-size: 26px;
                    line-height: 24px;
                }
            }
        }

        // TODO later

        .flight-bottom-data {
            display: flex;
            max-width: 100%;
            flex-wrap: wrap;

            .input-block {
                max-width: unset;
                padding: 10px;
                flex-basis: 100%;
                width: 100%;

                >>> .error-message {
                    left: 11px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/forms_entities/MultiCityForm.vue